<template>
  <div>
    <div style="padding:5px 5px 5px 5px">
      <div id="hello-hello">
        <p style="display:inline;float: left;line-height: 22px;"><b>员工统计</b></p>

        <el-date-picker v-model="createdTime" type="month" placeholder="选择月" @change="monthChange">
        </el-date-picker>

        <el-select v-model="maker" placeholder="请选择计件人" style="width:220px" @change="monthChange">
          <el-option v-for="item in empList" :key="item.value" :label="item.employeeName" :value="item.userId">
          </el-option>
        </el-select>
        
      </div>
    </div>

    <div style="margin-bottom:20px;">
      <div style="display:flex;margin: 2px 0;">
        <div style="width:90%;"></div>
        <div style="width:80px;background-color: lightblue;color: black;padding: 2px 0;">合格数</div>
      </div>

    </div>

    <template>
      <div style="display:flex;flex-wrap: wrap;border-right: 1px solid green;border-bottom: 1px solid green;">
        <div v-for="item in reckonCountList" :key="item.id"
          style="width:14.2%;border-top: 1px solid green;border-left: 1px solid green;">

          <div style="padding:5px 0;font-size: 16px;">{{ item.reportDate }}</div>

          <div style="display:flex;">
            <div
              style="background-color: lightblue;color: black;padding:5px 0;width: 100%;height: 70px;line-height: 70px;">{{
                item.qualifiedQuantity == null ? "-" : item.qualifiedQuantity }}</div>
          </div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import router from '../../router';

export default {
  name: "ReckonStatistic",
  data() {
    return {
      token: this.getToken(),
      userId: this.getUserId(),
      companyId: this.getCompanyId(),

      createdTime: new Date(),
      
      empList: [],
      maker: '',

      pageIndex: -1,
      pageNum: -1,
      
      drawer: false,
      direction: 'rtl',
      id: '',
      companyName: '',
      reckonCountList: [{
        date: 1
      }, {
        date: 2
      }, {
        date: 3
      }, {
        date: 4
      }, {
        date: 5
      }, {
        date: 6
      }, {
        date: 7
      }]
    };
  },
  methods: {
    monthChange() {
      this.$axios({
        method: "post",
        url: "/shiro/report/work/statistic",
        data: {
          maker: this.maker,
          createdTime: this.createdTime,
          companyId: this.companyId
        },
        headers: {
          token: this.token
        }
      }).then(result => {

        const data = result.data

        this.reckonCountList = data.data
      })
    },
    getAllEmp() {
      this.$axios({
        method: "post",
        url: "/shiro/employee/getAll",
        data: {
          pageIndex: -1,
          pageNum: -1,
          companyId: this.companyId
        }, headers: {
          token: this.token
        }
      }).then(result => {

        const data = result.data

        if (data.status === 400) {
          this.$router.push({ path: "/Login" })
        }

        this.empList = data.data
      })
    }

  },
  mounted() {
    this.setDefaultPath('/reckonStatistic')
    
    this.getAllEmp()
  }
};
</script>

<style>
#create_company {
  position: relative;
  right: 5px;
  width: 120px;
}

#cancel_determine {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
</style>